import { Component } from "react"
import { Container, Row, Col, } from "reactstrap"
import { withTranslation } from 'react-i18next'
import i18n from 'i18next'
import { FaInfoCircle } from "react-icons/fa"


class FAQContact extends Component {


  render() {
    const { t } = this.props
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined

    let iframeUrl = "";
    switch (language) {
      case "fr":
        iframeUrl = "https://sibforms.com/serve/MUIFAHgFof8uQB9h4Igq3sa2CQdH97hauXV5xcO_I_M0kjrjhmTigJfujOjZl6l_EYrRI6wAH_39Uem5JWVp9kGxTUCROlXxLClZAlK5Eit6ZozU5HK3PFxe0sLEe-Kr9jkOIyY7jG0_3GS9yTeCghQ2ZUPtvYi4LULIYfW202px2CksFlTGsDPWBsbgRUtRqynIvPf1uNFUNe_E";
        break;
      case "en":
        iframeUrl = "https://sibforms.com/serve/MUIFAPp7SVefd6I2QFqg21MAPeafrJMhcwwG_ZGO2PTO9TqrfWeCIRQAHY449SCncOKWPByQahdO-5IE0e_ankIh7pqpdIgs6mfgt8dYks9R-lOVuYxz_BQhCVXkrTbP7kDYUUlnlQNylSSdXe-1EyHsFXqRT9zjTc6ZjUo5SQvpztyiJI7_wVV-fUkLQlqleNLSkUJPcJbuQfWF";
        break;
      case "es":
        iframeUrl = "https://sibforms.com/serve/MUIFAMCNGYZoYYj533E6LbdOyXB4HqR08prporcyx8IHeO-8IMqi7aBolJ8XKdIqTsDxz_4cr6bw-tsKt4d5pYiUUl_ig2v--DlQwy5rnf6Ri7MoRPnO5Ge5cxCUqn1sYDn0EEJMi7TN-IfpOcBoV0w5jCM30JCm-fYU44BCQOMV3ycrGzmrStMcSI217JxmoaeLkucqY1rEZR7K";
        break;
      default:
        iframeUrl = "https://sibforms.com/serve/MUIFAHgFof8uQB9h4Igq3sa2CQdH97hauXV5xcO_I_M0kjrjhmTigJfujOjZl6l_EYrRI6wAH_39Uem5JWVp9kGxTUCROlXxLClZAlK5Eit6ZozU5HK3PFxe0sLEe-Kr9jkOIyY7jG0_3GS9yTeCghQ2ZUPtvYi4LULIYfW202px2CksFlTGsDPWBsbgRUtRqynIvPf1uNFUNe_E";
    }


    return (
      <div className='white-grey-bg'>
        <Container className='my-5 pb-5'>


          <Row className="justify-content-center">
            {/* Bloc gauche : FAQ */}
            <Col xs={12} md={7} className="text-center px-md-5 px-3 mb-2 mb-md-0">
              <h2 className="pb-3 dark-blue second-title">
                {t("faq|Titre")}
              </h2>
              <p className="mb-4">{t("faq|Texte")}</p>
              <a href="/faq" className="btn btn-nah mb-3 small">
                <FaInfoCircle className="fix-icon-pad mr-2" size={20} />
                {t("faq|Consulter la FAQ Nahibu")}
              </a>
            </Col>

            {/* Bloc droit : Formulaire */}
            <Col xs={12} md={12}>
              <p className="text-center pb-3 pt-2 px-5">
                <i>{t("faq|Formulaire-intro")}</i>
              </p>

              <div className="bg-light p-4 rounded shadow-sm" style={{ maxWidth: '460px', margin: '0 auto' }}>
                <iframe
                  title="Form contact Nahibu"
                  src={iframeUrl}
                  allowFullScreen
                  style={{
                    display: "block",
                    margin: "0 auto",
                    height: "400px",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    width: "100%"
                  }}
                />
                <p className="mt-3 text-center text-muted small">
                  {t("faq|Reponse-rapide")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default withTranslation()(FAQContact)
